/**
 * Formatta una quantità di minuti nel formato H:MM (es. 270 => "4:30").
 * Usato per la disponibilità oraria delle sale riunioni.
 */
export default function FormatMinutiToOre(minuti) {
  const totMinuti = Number.isFinite(minuti) && minuti > 0 ? Math.round(minuti) : 0;
  const ore = Math.floor(totMinuti / 60);
  const resto = totMinuti % 60;

  return `${ore}:${resto.toString().padStart(2, "0")}`;
}
